export default __webpack_public_path__ + "static/media/sh-logo-blue.9b7bcffb.svg";